import { Components, Theme } from '@mui/material';

export function getMuiTableCell(theme: Theme): Components['MuiTableCell'] {
  return {
    styleOverrides: {
      head: {
        fontSize: 14,
        lineHeight: 1.43,
        fontWeight: 700,
        fontFeatureSettings: "'calt' off",
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(3),

        '&:first-of-type': {
          paddingLeft: theme.spacing(8),
          borderTopLeftRadius: theme.shape.borderRadiusLg,
          borderBottomLeftRadius: theme.shape.borderRadiusLg,
        },

        '&:last-of-type': {
          paddingRight: theme.spacing(8),
          borderTopRightRadius: theme.shape.borderRadiusLg,
          borderBottomRightRadius: theme.shape.borderRadiusLg,
        },
      },

      body: {
        fontSize: 14,
        lineHeight: 1.43,
        fontWeight: 400,
        fontFeatureSettings: "'calt' off",
        color: theme.palette.grey[900],
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),

        '&:first-of-type': {
          paddingLeft: theme.spacing(8),
          borderTopLeftRadius: theme.shape.borderRadiusLg,
          borderBottomLeftRadius: theme.shape.borderRadiusLg,
        },

        '&:last-of-type': {
          paddingRight: theme.spacing(8),
          borderTopRightRadius: theme.shape.borderRadiusLg,
          borderBottomRightRadius: theme.shape.borderRadiusLg,
        },
      },
    },
  };
}
